export default __webpack_public_path__ + "static/media/campana-puntos-engagement.9966ac0b.png";